import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

/* In/Out of School Suspensions
 *
 * Uses:
 *      School
 *      Infraction
 *      Start Date
 *      End Date
 *      Show Detail
 *      Sort By
 */

@Component({
	templateUrl: "./studentsbyinfraction.component.html",
})
export class StudentsByInfractionComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		InfractionID: 0,
		startDate: new Date(),
		endDate: new Date(),
		ShowDetail: "Yes",
		SortBy: "Date",
		ImageLogo: "",
	};

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	schoolList: any = [];
	infractionList: any = [];
	ImageLogoList: any = [];

	showDetailList = [
		{
			ShowDetail: "Yes",
			ShowDetailDesc: "Yes",
		},
		{
			ShowDetail: "No",
			ShowDetailDesc: "No",
		},
	];

	lstSortBy = [
		{
			SortBy: "Date",
			SortByDesc: "Date",
		},
		{
			SortBy: "Grade",
			SortByDesc: "Grade",
		},
		{
			SortBy: "Homeroom",
			SortByDesc: "Homeroom",
		},
		{
			SortBy: "Infraction",
			SortByDesc: "Infraction",
		},
		{
			SortBy: "Name",
			SortByDesc: "Name",
		},
		{
			SortBy: "Penalty",
			SortByDesc: "Penalty",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 155;

	subscription: any;

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	ngOnInit() {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	//School List
	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(155);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	//Infraction List
	private InfractionList() {
		this.report.InfractionID = 0;
		var result = this.reportService.InfractionGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.infractionList = response;

				if (this.infractionList.length > 1) {
					this.infractionList.unshift({
						InfractionID: 0,
						InfractionDesc: "All Infractions",
					});
				} else {
					this.report.InfractionID = this.infractionList[0].InfractionID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	//On School Change Event
	onSchoolChange(SchoolID: any) {
		this.report.SchoolID = SchoolID;

		this.InfractionList();
		this.loadLogolist();
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 155;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += "<ROOT><School SchoolID='" + this.report.SchoolID + "'/></ROOT>";
		strParam += "|SchoolXML";
		strParam += "," + this.report.InfractionID + "|InfractionID";
		strParam += "," + moment(this.report.startDate).format("MM/DD/YYYY") + "|StartDate";
		strParam += "," + moment(this.report.endDate).format("MM/DD/YYYY") + "|EndDate";
		strParam += "," + this.report.ShowDetail + "|ShowDetail";
		strParam += "," + this.report.SortBy + "|OrderBy";
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
